import React from "react";
import { useSearchParams } from "react-router-dom";
import { Bot, Gauge, RadioTower } from "lucide-react";
import { OpsPage, OpsTabs } from "../operations/ui";
import { DistributionSection } from "../operations/sections/DistributionSection";
import { AutomationSection } from "../operations/sections/AutomationSection";
import { SystemSection } from "../operations/sections/SystemSection";

const tabs = [
  { key: "distribution", label: "Distribution", icon: RadioTower },
  { key: "automation", label: "Automation", icon: Bot },
  { key: "system", label: "System", icon: Gauge },
];

const OperationsOutput = () => {
  const [params, setParams] = useSearchParams();
  const requested = params.get("tab");
  const active = tabs.some((tab) => tab.key === requested) ? requested : "distribution";

  return (
    <OpsPage
      icon={RadioTower}
      title="Output"
      eyebrow="Destinations · Relay · Automation · Diagnostics"
      actions={<OpsTabs tabs={tabs} active={active} onChange={(key) => setParams({ tab: key }, { replace: true })} />}
    >
      {active === "distribution" && <DistributionSection />}
      {active === "automation" && <AutomationSection />}
      {active === "system" && <SystemSection />}
    </OpsPage>
  );
};

export default OperationsOutput;
